import React from 'react';
import Footer from '../Footer/Footer';
import { BrandId, getBrandIdFromHostname } from '@delta-defense/delta-utils';
import { getStylesByBrand } from '../../utilities/getStylesByBrand';
import { getLogoByBrand } from '../../utilities/getLogoByBrand';
import { EmbedService } from '../../core/services/embedService';

function Layout({ children, embedService = EmbedService.Instance() }) {
  const brandId = getBrandIdFromHostname();
  const brandLogo = getLogoByBrand(brandId as BrandId);
  const brandStyles = getStylesByBrand(brandId as BrandId);

  return embedService.isEmbedded ? (
    <div className={`fixed-col-${brandStyles?.className} main fascia-${brandId} pt-3 pt-sm-5 mx-auto embedded`}>
      <div className={`${brandStyles?.className}`}>
        {children}
      </div>
    </div>
  ) : (
    <>
      <div className={`fixed-col-${brandStyles?.className} main fascia-${brandId} pt-3 pt-sm-5 mx-auto`}>
        <div className={`${brandStyles?.className}`}>
          {brandLogo}
          <div className="mt-5">{children}</div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Layout;
